import { getPageByUrlSlug, getUrlSlugByCodename } from "@lib/kontent"
import { ContentPage as ContentPageModel } from "@lib/kontent/models-deprecated/content_page"
import { PageProps } from "@lib/types"
import ContentPageScreen from "@screens/content-page"
import { ErrorPage } from "@screens/error"
import { NextPage } from "next"

type Props = PageProps<ContentPageModel> & {
  uid: string
  altUrlSlug?: string | null
}

const ContentPage: NextPage<Props> = ({ data, altUrlSlug, statusCode }) => {
  if (statusCode) {
    return <ErrorPage statusCode={statusCode} />
  }
  if (!data) {
    return <ErrorPage statusCode={500} />
  }

  return <ContentPageScreen collection={data} altSlug={altUrlSlug} />
}

ContentPage.getInitialProps = async ({ lang, query }) => {
  const uid = query.uid as string
  const altLang = lang === "nl" ? "en" : "nl"
  try {
    // Get page content in right language
    const content = (await getPageByUrlSlug({
      type: "content_page",
      urlSlug: uid,
      lang,
    })) as ContentPageModel

    // If visiting a page that doesn't exist, return 404
    if (!content) {
      return { statusCode: 404, uid }
    }

    // Get page URL slug of its EN|NL counterpart
    const altUrlSlug = (await getUrlSlugByCodename({
      codename: content.system.codename,
      lang: altLang,
    })) as string | null

    return {
      data: content as ContentPageModel,
      altUrlSlug,
      uid,
    }
  } catch (error) {
    console.error(error)
    return { statusCode: 500, uid }
  }
}

export default ContentPage
